module.exports = __webpack_public_path__ + "img/s2.547b7f4e.png";